<div class="options-container">
  @if (!chunk?.isPlaceHolder) {
    <div class="options-grid">
      @if (canUseAI) {
        <app-generate-content (clicked)="triggerAIPane()"></app-generate-content>
      }

      <app-add-math-equation-option (actionTriggered)="onMathEquationGenerated($event)"></app-add-math-equation-option>

      <app-add-code-option [chunk]="chunk" (actionTriggered)="onAction()"></app-add-code-option>

      <app-add-table-option (actionTriggered)="onAction()"></app-add-table-option>

      <app-add-canvas-option [chunk]="chunk" (actionTriggered)="onAction()"></app-add-canvas-option>

      <app-add-whiteboard-option [chunk]="chunk" (actionTriggered)="onAction()"></app-add-whiteboard-option>

      <app-chunk-file-uploader [params]="chunk" [data]="data" (uploadComplete)="onUploadComplete()"></app-chunk-file-uploader>
      <app-video-recorder [data]="data"></app-video-recorder>
      @if (isScreenShareSupported) {
        <app-screen-recorder [data]="data"></app-screen-recorder>
      }
      <app-photo-recorder [data]="data"></app-photo-recorder>
      <app-add-tag-option [chunk]="chunk" [courseID]="courseID" [blogID]="blogID" (actionTriggered)="onAction()" />
      @if (chunk.type === 'video') {
        <app-generate-video-procedure-option [chunk]="chunk" [contentID]="contentID" (actionTriggered)="onAction()" />
      }
      @if (chunk.type === 'video') {
        <app-analyze-media-option [chunk]="chunk" [contentID]="contentID" (actionTriggered)="onAction()" />
      }
      @if (chunk.type === 'video') {
        <app-transcribe-video-option [chunk]="chunk" [contentID]="contentID" (actionTriggered)="onAction()" />
      }
      <!-- TODO: RTA-1905 -->
      <!-- @if (['audio', 'video', 'image', 'file'].includes(chunk.type)) {
        <app-add-edition-option [chunk]="chunk" (actionTriggered)="onAction()" />
      } -->
      @if (false) {
        <app-generate-embeddings-option [chunk]="chunk" (actionTriggered)="onAction()" />
      }
      <!-- @if (['text', 'html', 'code'].includes(chunk.type)) {
        <app-add-audio-option [chunk]="chunk" (actionTriggered)="onAction()" />
        <app-voice-over-option [chunk]="chunk" (actionTriggered)="onAction()" />
      } -->
      @if (chunk?.error) {
        <app-fix-creation-option [chunk]="chunk" (actionTriggered)="onAction()" />
      }
    </div>
    <mat-divider />
  }
  <div class="options-footer">
    <app-select-chunk [chunk]="chunk" (actionTriggered)="onAction()" />
    <app-delete-chunk [chunk]="chunk" [contentID]="contentID" (deleted)="onDeleted()" (actionTriggered)="onAction()" />
  </div>
</div>
